import { css } from '@emotion/react';
import { getColor } from '@atlassiansox/wpl-utils';

export const familyLogoWrapperStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: ${getColor('b300')};
  width: 36px;
  height: 36px;
  padding: 9px;
`;

export const logoStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 9px;
`;
